<ng-container *ngIf="propertyDetailsPage">
<div  class="fancy-hero-one">
  <div class="container">
    <div class="row">
      <div class="col-xl-9 col-lg-11 m-auto">
        <!-- <div class="page-title">Contact us</div> -->
        <h2 class="font-rubik">Asset Detail</h2>
      </div>
    </div>
  </div>
</div>

<div class="hero-banner-one contact-us-light">
  <div class="hero-upper-container">
    <div *ngIf="redirection_payment == 'FAILED'" class="mb-25" style="color: red;"> 
      Your payment transaction has failed. Please try again.
  </div>
    <div class="container">
      <div class="details_wrap">
        <ul>
          <li><label>Asset ID : </label>{{property_detail?.property_uid}}</li>
          <li><label>Name of Household : </label>{{property_detail?.consumer?.name}}</li>
          <!-- <li><label>Email : </label>{{property_detail?.consrumer?.email}}</li> -->
          <li><label>Address : </label>{{property_detail?.consumer?.address}}</li>
        </ul>
        <ul>
          <li><label>Asset Type : </label> {{property_detail?.property_type?.type_name}}</li>
          <li><label>ULB : </label> {{property_detail?.ulb?.name}}</li>
          <li><label>Zone : </label> {{property_detail?.region?.parents?.region_name}}</li>
          <li><label>Ward : </label> {{property_detail?.region?.region_name}}</li>
        </ul>
      </div>

      <div class="table_wrap">
        <table class="table table_design mt-100">
          <thead>
            <tr>
              <th scope="col">Service Identifier</th>
              <th scope="col">Service Type</th>
              <th scope="col">Area</th>
              <th scope="col">Current Bill Amount</th>
              <th scope="col">Arrear</th>
              <th scope="col">Total Due</th>
              <!-- <th  *ngIf="property_detail.services.length > 1"  scope="col"><input style="margin-left: 10px;" type="checkbox" [(ngModel)]="selectAll"
                  (ngModelChange)="onSelectAllChange()">Select All</th> -->
              <th scope="col">Select</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of property_detail.services; index as i">
              <td scope="row">
                <span *ngIf="property_detail.is_approved == false">Pending Approval</span>
                <span *ngIf="property_detail.is_approved == true">{{ data?.service_identifier}}</span>
              </td>
              <td scope="row">{{ data?.service_type?.name }}</td>
              <td scope="row">{{ data?.area }}</td>
              <td scope="row">{{ data?.amount | currency:'INR' }}</td>
              <td scope="row">{{ data?.last_due | currency:'INR' }}</td>
              <td scope="row">{{ data?.payable_total_amount | currency:'INR' }}</td>
              <td scope="row">
                <input type="radio" name="selectedItem" [value]="i" [(ngModel)]="selectedRowIndex"
                (change)="amount = data?.payable_total_amount">   
              </td>
              <!-- <td scope="row" class="text-center"><button [routerLink]="['/bill-details/' + data.service_identifier]" class="theme-btn-one">Pay</button></td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="form-style-light input_pay" *ngIf="property_detail?.services && property_detail?.services.length">
        <div class="pay_details" >
          <ul>
            <li><label>Service Identifier : </label> {{property_detail?.services[selectedRowIndex].service_identifier}}</li>
            <li><label>Service Type : </label> {{property_detail?.services[selectedRowIndex].service_type?.name}}</li>
            <li><label>Area : </label> {{property_detail?.services[selectedRowIndex].area}}</li>
          </ul>
          <ul>
            <li><label>Current Bill Amount : </label> {{property_detail?.services[selectedRowIndex].amount | currency:'INR' }}</li>
            <li><label>Arrear : </label> {{property_detail?.services[selectedRowIndex].last_due | currency:'INR' }}</li>
            <li><label>Total Due : </label> {{property_detail?.services[selectedRowIndex].payable_total_amount | currency:'INR' }}</li>
          </ul>
        </div>

        <a href="javascript:;" style="text-decoration: underline;" (click)="amount = property_detail?.services[selectedRowIndex].payable_total_amount; is_partial_payment = false">Pay Total Due</a>
        <a  href="javascript:;" style="text-decoration: underline; margin-left: 10px;" (click)="amount = property_detail?.services[selectedRowIndex].minimum_payable_amount; is_partial_payment = false">Pay Minimum</a>
        <a  href="javascript:;" style="text-decoration: underline; margin-left: 10px;" (click)="amount = property_detail?.services[selectedRowIndex].minimum_payable_amount; is_partial_payment = true">Enter Other Amount</a>

        <div class="input-group-meta form-group pay_input" style="margin-top: 20px;">
          <label>Amount</label>
          <input type="number" [disabled]="!is_partial_payment" name="amount" #amountInpt="ngModel" [(ngModel)]="amount"
            [min]="property_detail?.services[selectedRowIndex].minimum_payable_amount"
            [max]="property_detail?.services[selectedRowIndex].payable_total_amount">
          <h6 style="display: block;" *ngIf="amountInpt.errors && (amountInpt.errors['min'] || amountInpt.errors['max'])">Amount must be
            between {{property_detail?.services[selectedRowIndex].minimum_payable_amount}} - {{property_detail?.services[selectedRowIndex].payable_total_amount}}</h6>
        </div>

        <button class="theme-btn-one btn-lg mt-20" [ngClass]="{'disabled': (amount == 0 ||  amountInpt.errors)}" (click)="onClickPay()">Pay</button>


      </div>
    </div>
  </div>
</div>
</ng-container>

<!-- <ng-container *ngIf="!propertyDetailsPage">
<div  class="fancy-hero-one">
  <div class="container">
    <div class="row">
      <div class="col-xl-9 col-lg-11 m-auto">
        <h2 class="font-rubik">Bill Details</h2>
      </div>
    </div>
  </div>
</div>

<div class="hero-banner-one contact-us-light">
  <div class="hero-upper-container">
    <div class="container">
      <form #paymentForm="ngForm" (submit)="makePayment()">
        <div class="details_wrap">
          <ul>
            <li><label>Name : </label>{{billData?.consumer?.name}}</li>
            <li><label>Email : </label>{{billData?.consumer?.email}}</li>
            <li><label>Mobile : </label>{{billData?.consumer?.mobile_no}}</li>
            <li><label>Address : </label>{{billData?.consumer?.address}}</li>
          </ul>
          <ul>
            <li><label>Current Amount : </label> {{billData?.bill?.amount}}</li>
            <li><label>Late Fees : </label> {{billData?.bill?.late_fee}}</li>
            <li><label>Due Date : </label> {{billData?.bill?.due_date | date : 'dd/MM/YYYY'}}</li>
            <li><label>Total Amount : </label> {{billData?.payable_total_amount}}</li>
          </ul>
          <div class="input-group-meta input_pay form-group mb-25">
            <label>Is Partial Payment</label>
            <input style="margin-left: 10px;" type="checkbox" name="is_partial_payment" [(ngModel)]="is_partial_payment"
              (ngModelChange)="onPartialPaymentChange()">
          </div>

          <div class="form-style-light input_pay">
            <div *ngIf="is_partial_payment" class="input-group-meta form-group mb-25">
              <label>Amount</label>
              <input type="number" name="amount" #amountInpt="ngModel" [(ngModel)]="amount"
                [min]="billData?.bill?.amount || 0">
              <h6 style="display: block;" *ngIf="amountInpt.errors && amountInpt.errors['min'].min">Amount must be
                greater than or equal to {{amountInpt.errors && amountInpt.errors['min'].min}}</h6>
            </div>
          </div>

          <button class="theme-btn-one btn-lg" [disabled]="!paymentForm.valid">Pay</button>
        </div>
      </form>
    </div>
  </div>
</div>
</ng-container> -->